import { BoardSectionEmbedWidget } from '#components/Board/Section/BoardSectionEmbedWidget';
import { BreakpointMedia } from '#cutils/breakpoints/media';
import type { SectionRaisedRightSimpleWeather } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD, IMAGE_SIZE_TWO_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionKiAssistant } from '../BoardSectionKiAssistant';
import { BoardSectionItemRichText } from '../Items/BoardSectionItemRichText';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

import styles from './BoardSectionTileRaisedRight2Weather.module.scss';

type Props = {
	section: SectionRaisedRightSimpleWeather;
};

export function BoardSectionTileRaisedRight2Weather({
	section: {
		introduction,
		kiAssistant,
		items: [left, right],
	},
}: Props) {
	if (left.type === 'empty' || right.type === 'empty') {
		return null;
	}

	const mobilePosition = kiAssistant?.position;
	const mobileWidget = kiAssistant ? (
		<BreakpointMedia lessThan="lg" className={styles.embedMediaWrapper}>
			<BoardSectionKiAssistant kiAssistant={kiAssistant} enableViewMode={false} />
		</BreakpointMedia>
	) : null;

	return (
		<>
			<BoardSectionTileSection>
				<BoardSectionTileRow>
					{mobilePosition === 0 ? mobileWidget : null}

					<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
						<BoardSectionItem teaser={left} isLarge={true} isPriority={true} key={left.rowId} sizes={IMAGE_SIZE_TWO_THIRD} />
					</Tracktor>

					<div className={styles.rightRoot}>
						{mobilePosition === 1 ? mobileWidget : null}

						<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
							<BoardSectionItem
								teaser={right}
								isPriority={false}
								key={right.rowId}
								sizes={IMAGE_SIZE_ONE_THIRD}
								className={kiAssistant ? styles.teaserFixedHeight : undefined}
							/>
						</Tracktor>

						<BreakpointMedia greaterThanOrEqual={mobilePosition === 2 || !kiAssistant ? 'xs' : 'lg'} className={styles.embedMediaWrapper}>
							<BoardSectionEmbedWidget kiAssistant={kiAssistant} />
						</BreakpointMedia>
					</div>
				</BoardSectionTileRow>
			</BoardSectionTileSection>
			<BoardSectionItemRichText introduction={introduction} />
		</>
	);
}
